import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/Button";
import React from "react";

const BackButton: React.FC<{ className?: string }> = ({ className = "" }) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => navigate(-1)}
      aria-label="Go back"
      className={className}
    >
      <ArrowLeft className="w-5 h-5" />
    </Button>
  );
};

export default BackButton;
